/**
 * Checks if the dateFrom for the product is set
 * If not, redirect to Step 1 of that flow.
 */
export default defineNuxtRouteMiddleware((to) => {
    const { product } = useProduct(to);
    const { firstStepRoute } = useFlow(to);

    if (!product.value.dateFrom) {
        return navigateTo(firstStepRoute.value);
    }
});
